import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardsLandingPage from './DashboardsLandingPage';
import DashboardsPage from './DashboardsPage';
import DashboardViewPage from './DashboardViewPage';
// @ts-ignore
import { useDashboardTour } from '../../tours/useDashboardTour';
// @ts-ignore
import { TourEngine } from '../../tours/TourEngine.jsx';
import { useAuth } from '../../context/useAuth';

export default function DashboardsContainer({ dashboardEditorState, setDashboardEditorState, handleBack, setActivePage, ...pageProps }: any) {
    const { token, user } = useAuth();
    const navigate = useNavigate();
    const { steps: tourSteps, run: tourRun, setRun: setTourRun, markSeen: markTourSeen, restartTour } = useDashboardTour(user?.id, token);

    let content;
    if (dashboardEditorState) {
        if (dashboardEditorState.mode === 'view') {
            content = <DashboardViewPage 
                {...pageProps} 
                dashboardId={dashboardEditorState.dashboardId} 
                studioFlow 
                onBack={() => {
                    setDashboardEditorState(null);
                    navigate('/dashboards');
                }} 
                onEdit={(id: string) => {
                    setDashboardEditorState({ mode: 'edit', dashboardId: id });
                    navigate(`/dashboards/${id}/edit`);
                }} 
            />;
        } else {
            content = <DashboardsPage 
                {...pageProps} 
                isEditMode={dashboardEditorState.mode === 'edit' || dashboardEditorState.mode === 'new'} 
                isNewDashboard={dashboardEditorState.mode === 'new'} 
                dashboardId={dashboardEditorState.dashboardId} 
                onBack={() => {
                    const dashboardId = dashboardEditorState.dashboardId;
                    if (dashboardId) {
                        setDashboardEditorState({ mode: 'view', dashboardId });
                        navigate(`/dashboards/${dashboardId}/view`);
                    } else {
                        setDashboardEditorState(null);
                        navigate('/dashboards');
                    }
                }} 
                onSaveComplete={() => {
                    const dashboardId = dashboardEditorState.dashboardId;
                    if (dashboardId) {
                        setDashboardEditorState({ mode: 'view', dashboardId });
                        navigate(`/dashboards/${dashboardId}/view`);
                    } else {
                        setDashboardEditorState(null);
                        navigate('/dashboards');
                    }
                }} 
                onNewDashboardSaved={(id: string) => {
                    setDashboardEditorState({ mode: 'edit', dashboardId: id });
                    navigate(`/dashboards/${id}/edit`, { replace: true });
                }} 
            />;
        }
    } else {
        content = <DashboardsLandingPage 
            {...pageProps}
            onCreateNew={() => {
                setDashboardEditorState({ mode: 'new' });
                navigate('/dashboards/create');
            }} 
            onEdit={(id: string) => {
                setDashboardEditorState({ mode: 'edit', dashboardId: id });
                navigate(`/dashboards/${id}/edit`);
            }} 
            onView={(id: string, dash: any) => {
                setDashboardEditorState({ mode: 'view', dashboardId: id });
                navigate(`/dashboards/${id}/view`);
            }} 
            onRestartTour={restartTour}
        />;
    }

    return (
        <>
            {content}
            <TourEngine
                steps={tourSteps}
                run={tourRun}
                setRun={setTourRun}
                markSeen={markTourSeen}
            />
        </>
    );
}
